module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lUUUU"))).then(() => parcelRequire('hEqeo'));